module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "logo"
  }, [(_vm.$i18n.locale == 'se') ? _c('img', {
    attrs: {
      "src": require("img/kunniakierros-logo-se.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("img/kunniakierros-logo-fi.png")
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error fadeout"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.state == 'username') ? _c('form', {
    key: "username",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.checkUsername($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "email",
      "autofocus": "",
      "placeholder": _vm.$t('user.username')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.requestingPin) ? _c('button', {
    staticClass: "button button-green",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("loginView.askForPin")))]) : _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("loginView.requestingPin")))])]) : (_vm.state == 'pin') ? _c('form', {
    key: "pin",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pin),
      expression: "pin"
    }],
    attrs: {
      "type": "number",
      "pattern": "[0-9]*",
      "autofocus": "",
      "placeholder": _vm.$t('user.pin')
    },
    domProps: {
      "value": (_vm.pin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pin = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button button-green",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("loginView.login")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("loginView.sendPinHelp")))]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendPin
    }
  }, [_vm._v(_vm._s(_vm.$t("loginView.sendPin")))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3664828","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/LoginView.vue
// module id = 130
// module chunks = 0